const state = () => {
  return {
    fail_list: null
  }
}

const actions = {}

const mutations = {
  setFailList(state, data) {
    state.fail_list = data
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
